import { getFlag } from 'sierra-client/config/global-config'

export const useIsEnabledMultiSelection = (): boolean => getFlag('bulk-actions')
